import UserProfileHeader from "../../../../../components/AdminPanel/userProfile/userProfileHeader";
import NavForSelfPacedUser from "../../../../../components/NewAcademicUser/Dashboard/Nav/NavForSelfPacedUser";
import "./myaccount.scss"

function SelfPacedUserProfile(props: any) {
  return (
    <>
      <NavForSelfPacedUser navbg navBgColorHandle />
      <div className="myaccount__wrapper">
      <div className="myaccount">
        <h1>My Account</h1>
        <UserProfileHeader />
      </div>
      </div>
    </>
  );
}

export default SelfPacedUserProfile;
